import React, { useState } from "react";
import { useFetch, useForm, usePending } from "state/hooks";
import { useSelector } from "react-redux";
import { selectSettingsId } from "playground/cms/state/selectors/settings";
import Button from "components/Button";
import Preloader from "components/Preloader";
import AggregateRoot from "containers/AggregateRoot";
import { FormSection, FormFieldset } from "playground/cms/Form";
import Field from "containers/Field";
import Favicon from "./Favicon";
import { useHasScope } from "playground/console/UserAccess";
import { SCOPE_WEBSITES_DEV } from "config/access-scopes";
import PageLayoutSettings from "./WebsiteSettings/PageLayoutSettings";

//import PropTypes from 'prop-types';

export function WebsiteSettings(props) {
    const {} = props;

    useFetch({
        type: "cms.settings",
        url: "cms/settings",
    });

    const id = useSelector((store) => selectSettingsId(store));
    const { onSubmit } = useForm("cms.settings", id, () => null);
    const isPending = usePending(id, false);

    const devAccess = useHasScope(SCOPE_WEBSITES_DEV);

    return (
        <AggregateRoot type={"cms.settings"} id={id} disableSubmit={true}>
            <div className={"settings-view"}>
                <div className={"settings-view-content"}>
                    <div className={"rows gap-md"}>
                        <FormSection name={"Logo"}>
                            <Field id={"media"} fieldType={"media"} />
                        </FormSection>
                        <FormSection name={"Favicon"}>
                            <Favicon />
                        </FormSection>
                        {devAccess && (
                            <FormSection name={"Wysyłka formularzy"}>
                                <Field
                                    id={"secure_forms"}
                                    fieldType={"checkbox"}
                                    label={
                                        "Zabeczpiecz formularze przed spamem (captcha)"
                                    }
                                />
                                <Field
                                    id={"forms_bot_protection"}
                                    fieldType={"checkbox"}
                                    label={
                                        "Dodatkowe zabezpieczenie przed botami"
                                    }
                                />
                                <Field
                                    id={"forms_capture_responses"}
                                    fieldType={"checkbox"}
                                    label={"Zapisuj odpowiedzi w bazie danych"}
                                />
                                <Field
                                    id={"forms_capture_rejected"}
                                    fieldType={"checkbox"}
                                    label={
                                        "Zapisuj odrzucone odpowiedzi (spam)"
                                    }
                                />
                                <Field
                                    id={"forms_disable_send"}
                                    fieldType={"checkbox"}
                                    label={"Nie wysyłaj formularzy mailem"}
                                />
                            </FormSection>
                        )}
                        <FormSection name={"SEO"}>
                            <FormFieldset>
                                <Field
                                    id={"seo_title_template"}
                                    label={"Szablon meta title"}
                                />
                                <Field
                                    id={"seo_title_default_template"}
                                    label={"Szablon domyślnego tytułu"}
                                />
                                <Field
                                    id={"footer_signature"}
                                    label={"Tekst w stopce"}
                                />
                            </FormFieldset>
                        </FormSection>
                        <FormSection name={"schema.org"}>
                            <Field id={"price_range"} label={"priceRange"} />
                        </FormSection>
                        <PageLayoutSettings {...props} id={id} />
                    </div>
                </div>
                <div className={"settings-view-footer cols-right"}>
                    <Button onClick={() => onSubmit()} size={"large"}>
                        Zapisz
                    </Button>
                </div>
            </div>
            <Preloader visible={isPending} />
        </AggregateRoot>
    );
}

WebsiteSettings.propTypes = {};

WebsiteSettings.defaultProps = {};

export default WebsiteSettings;
